import { Trash01Icon } from '@/components/icons/Trash01Icon';

import {
  TileNodeControlButton,
  TileNodeControlButtonProps,
} from './TileNodeControlButton';

export const DeleteTileControlButton = (props: TileNodeControlButtonProps) => {
  return (
    <TileNodeControlButton
      data-testid="delete-tile-control-button"
      square={false}
      startIcon={Trash01Icon}
      {...props}
    >
      Delete
    </TileNodeControlButton>
  );
};
